export const MAINTENANCE_DATA = [
  {
    model: 'AA112',
    description: '00001',
    updateAt: '2020/01/30',
    status: 'NORMAL',
    frequency: 10
  },
  {
    model: 'AA112',
    description: '00001',
    updateAt: '2020/01/30',
    status: 'MALFUNCTION',
    frequency: 10
  },
  {
    model: 'AA112',
    description: '00001',
    updateAt: '2020/01/30',
    status: 'WAITING',
    frequency: 13
  },
  {
    model: 'AA112',
    description: '00001',
    updateAt: '2020/01/30',
    status: 'MALFUNCTION',
    frequency: 13
  },
  {
    model: 'AA112',
    description: '00001',
    updateAt: '2020/01/30',
    status: 'NORMAL',
    frequency: 13
  },
  {
    model: 'AA112',
    description: '00001',
    updateAt: '2020/01/30',
    status: 'WAITING',
    frequency: 13
  },
  {
    model: 'AA112',
    description: '00001',
    updateAt: '2020/01/30',
    status: 'WAITING',
    frequency: 14
  },
  {
    model: 'AA112',
    description: '00001',
    updateAt: '2020/01/30',
    status: 'REPAIRING',
    frequency: 23
  },
  {
    model: 'AA112',
    description: '00001',
    updateAt: '2020/01/30',
    status: 'REPAIRING',
    frequency: 23
  },
  {
    model: 'AA112',
    description: '00001',
    updateAt: '2020/01/30',
    status: 'REPAIRING',
    frequency: 23
  },
  {
    model: 'AA112',
    description: '00001',
    updateAt: '2020/01/30',
    status: 'MAINTENANCE',
    frequency: 14
  },
  {
    model: 'AA112',
    description: '00001',
    updateAt: '2020/01/30',
    status: 'MAINTENANCE',
    frequency: 14
  }
]

export const BIKE_MANAGEMENT = [
  {
    model: 'AA112',
    id: '00001',
    rental: 'Reserved',
    status: 'NORMAL',
    productionDate: '2020/02/11',
    battery: '7%',
    maintenance: '淡江店'
  },
  {
    model: 'AA112',
    id: '00002',
    rental: 'Reserved',
    status: 'NORMAL',
    productionDate: '2020/02/11',
    battery: '7%',
    maintenance: '淡江店'
  },
  {
    model: 'AA112',
    id: '00003',
    rental: 'Reserved',
    status: 'NORMAL',
    productionDate: '2020/02/12',
    battery: '7%',
    maintenance: '淡江店'
  },
  {
    model: 'AA112',
    id: '00004',
    rental: 'Reserved',
    status: 'NORMAL',
    productionDate: '2020/02/12',
    battery: '7%',
    maintenance: '淡江店'
  },
  {
    model: 'AA112',
    id: '00005',
    rental: 'Reserved',
    status: 'NORMAL',
    productionDate: '2020/02/12',
    battery: '7%',
    maintenance: '淡江店'
  },
  {
    model: 'AA112',
    id: '00006',
    rental: 'Reserved',
    status: 'NORMAL',
    productionDate: '2020/02/12',
    battery: '88%',
    maintenance: '淡江店'
  },
  {
    model: 'AA112',
    id: '00007',
    rental: 'Reserved',
    status: 'NORMAL',
    productionDate: '2020/02/14',
    battery: '88%',
    maintenance: '淡江店'
  },
  {
    model: 'AA112',
    id: '00008',
    rental: 'Reserved',
    status: 'REPAIRING',
    productionDate: '2020/02/15',
    battery: '88%',
    maintenance: '淡江店'
  },
  {
    model: 'AA112',
    id: '00009',
    rental: 'Reserved',
    status: 'REPAIRING',
    productionDate: '2020/02/15',
    battery: '88%',
    maintenance: '淡江店'
  },
  {
    model: 'AA112',
    id: '00010',
    rental: 'Reserved',
    status: 'REPAIRING',
    productionDate: '2020/02/15',
    battery: '88%',
    maintenance: '淡江店'
  },
  {
    model: 'AA112',
    id: '00011',
    rental: 'Reserved',
    status: 'MAINTENANCE',
    productionDate: '2020/02/14',
    battery: '88%',
    maintenance: '淡江店'
  },
  {
    model: 'AA112',
    id: '00012',
    rental: 'Reserved',
    status: 'MAINTENANCE',
    productionDate: '2020/02/14',
    battery: '88%',
    maintenance: '淡江店'
  }
]

export const RENTALS = [
  {
    userName: 'Frozen Yogurt',
    userEmail: 'judy@ebike.com',
    bikeID: 'TP8823',
    status: 'RESERVED',
    scheduleTime: '2020/02/11',
    updateAt: '2020/02/20',
    note: '21312'
  },
  {
    userName: 'Ice cream sandwich',
    userEmail: 'judy@ebike.com',
    bikeID: 'TP8823',
    status: 'RESERVED',
    scheduleTime: '2020/02/11',
    updateAt: '2020/02/20',
    note: '21312'
  },
  {
    userName: 'Eclair',
    userEmail: 'judy@ebike.com',
    bikeID: 'TP8823',
    status: 'RESERVED',
    scheduleTime: '2020/02/12',
    updateAt: '2020/02/20',
    note: '21312'
  },
  {
    userName: 'Cupcake',
    userEmail: 'judy@ebike.com',
    bikeID: 'TP8823',
    status: 'RESERVED',
    scheduleTime: '2020/02/12',
    updateAt: '2020/02/20',
    note: '21312'
  },
  {
    userName: 'Gingerbread',
    userEmail: 'judy@ebike.com',
    bikeID: 'TP8823',
    status: 'SERVICING',
    scheduleTime: '2020/02/12',
    updateAt: '2020/02/20',
    note: '21312'
  },
  {
    userName: 'Jelly bean',
    userEmail: 'judy@ebike.com',
    bikeID: 'TP8823',
    status: 'RESERVED',
    scheduleTime: '2020/02/12',
    updateAt: '2020/02/22',
    note: '21312'
  },
  {
    userName: 'Lollipop',
    userEmail: 'judy@ebike.com',
    bikeID: 'TP8823',
    status: 'SERVICING',
    scheduleTime: '2020/02/14',
    updateAt: '2020/02/22',
    note: '21312'
  },
  {
    userName: 'Honeycomb',
    userEmail: 'judy@ebike.com',
    bikeID: 'TP8823',
    status: 'MALFUNCTION',
    scheduleTime: '2020/02/15',
    updateAt: '2020/02/22',
    note: '21312'
  },
  {
    userName: 'Honeycomb',
    userEmail: 'judy@ebike.com',
    bikeID: 'TP8823',
    status: 'MALFUNCTION',
    scheduleTime: '2020/02/15',
    updateAt: '2020/02/22',
    note: '21312'
  },
  {
    userName: 'Honeycomb',
    userEmail: 'judy@ebike.com',
    bikeID: 'TP8823',
    status: 'RETUREND',
    scheduleTime: '2020/02/15',
    updateAt: '2020/02/22',
    note: '21312'
  },
  {
    userName: 'Donut',
    userEmail: 'judy@ebike.com',
    bikeID: 'TP8823',
    status: 'RETUREND',
    scheduleTime: '2020/02/14',
    updateAt: '2020/02/22',
    note: '21312'
  },
  {
    userName: 'KitKat',
    userEmail: 'judy@ebike.com',
    bikeID: 'TP8823',
    status: 'RETUREND',
    scheduleTime: '2020/02/14',
    updateAt: '2020/02/22',
    note: '21312'
  }
]

export const MEMBERS = [
  {
    id: 1,
    userName: 'Judy',
    phoneNumber: '0912345678',
    userEmail: 'judy@ebike.com',
    lastRentalAt: '2020/05/20'
  },
  {
    id: 2,
    userName: 'Judy',
    phoneNumber: '0912345678',
    userEmail: 'judy@ebike.com',
    lastRentalAt: '2020/06/20'
  },
  {
    id: 3,
    userName: 'Judy',
    phoneNumber: '0912345678',
    userEmail: 'judy@ebike.com',
    lastRentalAt: '2020/01/20'
  },
  {
    id: 4,
    userName: 'Judy',
    phoneNumber: '0912345678',
    userEmail: 'judy@ebike.com',
    lastRentalAt: '2020/03/20'
  },
  {
    id: 5,
    userName: 'Judy',
    phoneNumber: '0912345678',
    userEmail: 'judy@ebike.com',
    lastRentalAt: '2020/04/20'
  }
]

export const USER_RENTAL_RECORD = [
  {
    startAt: '2020/02/12 15:00',
    endAt: '2020/02/12 18:00',
    totalPeriod: 170
  },
  {
    startAt: '2020/02/12 15:00',
    endAt: '2020/02/12 18:00',
    totalPeriod: 170
  },
  {
    startAt: '2020/02/12 15:00',
    endAt: '2020/02/12 18:00',
    totalPeriod: 170
  },
  {
    startAt: '2020/02/12 15:00',
    endAt: '2020/02/12 18:00',
    totalPeriod: 170
  },
  {
    startAt: '2020/02/12 15:00',
    endAt: '2020/02/12 18:00',
    totalPeriod: 170
  },
  {
    startAt: '2020/02/12 15:00',
    endAt: '2020/02/12 18:00',
    totalPeriod: 170
  }
]

export const FAKE_SITE_INFO = {
  name: 'MRT Xinyi Anhe Site',
  operation: '正常營運',
  available: 3,
  bikeRacks: 12,
  power: 'FUNCTIONAL',
  location: '台北市大安區',
  unit: '台北市大安區',
  notification: false,
  suspended: false,
  state: 1
}

export const SITE_MANAGEMENT = [
  {
    id: 'TP8821',
    name: '內湖1站',
    location: '台北市內湖區瑞光路2號',
    circumference: 25000,
    bikeRacks: 25,
    startAt: '2020-01-08T00:00:00',
    status: 1
  },
  {
    id: 'TP8822',
    name: '內湖2站',
    location: '台北市內湖區瑞光路2號',
    circumference: 25000,
    bikeRacks: 25,
    startAt: '2020-01-08T00:00:00',
    status: 0
  },
  {
    id: 'TP8823',
    name: '內湖3站',
    location: '台北市內湖區瑞光路2號',
    circumference: 25000,
    bikeRacks: 25,
    startAt: '2020-01-08T00:00:00',
    status: 1
  },
  {
    id: 'TP8824',
    name: '內湖4站',
    location: '台北市內湖區瑞光路2號',
    circumference: 25000,
    bikeRacks: 25,
    startAt: '2020-01-08T00:00:00',
    status: 0
  },
  {
    id: 'TP8825',
    name: '內湖5站',
    location: '台北市內湖區瑞光路2號',
    circumference: 25000,
    bikeRacks: 25,
    startAt: '2020-01-08T00:00:00',
    status: 1
  },
  {
    id: 'TP8826',
    name: '內湖6站',
    location: '台北市內湖區瑞光路2號',
    circumference: 25000,
    bikeRacks: 25,
    startAt: '2020-01-08T00:00:00',
    status: 1
  },
  {
    id: 'TP8827',
    name: '內湖7站',
    location: '台北市內湖區瑞光路2號',
    circumference: 25000,
    bikeRacks: 25,
    startAt: '2020-01-08T00:00:00',
    status: 0
  },
  {
    id: 'TP8828',
    name: '內湖8站',
    location: '台北市內湖區瑞光路2號',
    circumference: 25000,
    bikeRacks: 25,
    startAt: '2020-01-08T00:00:00',
    status: 0
  },
  {
    id: 'TP8829',
    name: '內湖9站',
    location: '台北市內湖區瑞光路2號',
    circumference: 25000,
    bikeRacks: 25,
    startAt: '2020-01-08T00:00:00',
    status: 0
  },
  {
    id: 'TP8830',
    name: '內湖10站',
    location: '台北市內湖區瑞光路2號',
    circumference: 25000,
    bikeRacks: 25,
    startAt: '2020-01-08T00:00:00',
    status: 1
  },
  {
    id: 'TP8831',
    name: '內湖11站',
    location: '台北市內湖區瑞光路2號',
    circumference: 25000,
    bikeRacks: 25,
    startAt: '2020-01-08T00:00:00',
    status: 1
  }
]

export const ACCESSORIES_MANAGEMENT = [
  {
    id: '001',
    store: 'A',
    name: '煞車皮',
    amount: 2
  },
  {
    id: '009',
    store: 'A',
    name: '擋泥板',
    amount: 2
  },
  {
    id: '002',
    store: 'B',
    name: '輪框',
    amount: 2
  },
  {
    id: '003',
    store: 'B',
    name: '擋泥板',
    amount: 2
  },
  {
    id: '004',
    store: 'C',
    name: '輪框',
    amount: 2
  },
  {
    id: '005',
    store: 'C',
    name: '煞車皮',
    amount: 2
  },
  {
    id: '006',
    store: 'D',
    name: '車燈',
    amount: 2
  },
  {
    id: '007',
    store: 'A',
    name: '坐墊',
    amount: 2
  },
  {
    id: '008',
    store: 'A',
    name: '輪胎',
    amount: 2
  }
]

export const ANALYTICS_OPERATION_DATA = [
  { month: 'Jan', revenue: 8000, cost: 5900, netProfit: 2100, powerConsumption: 1000 },
  { month: 'Feb', revenue: 7000, cost: 4300, netProfit: 2700, powerConsumption: 2000 },
  { month: 'Mar', revenue: 5000, cost: 5400, netProfit: -400, powerConsumption: 4000 },
  { month: 'Apr', revenue: 8000, cost: 5800, netProfit: 2200, powerConsumption: 1000 },
  { month: 'May', revenue: 7669, cost: 7300, netProfit: 369, powerConsumption: 2669 },
  { month: 'Jun', revenue: 8232, cost: 5300, netProfit: 2932, powerConsumption: 1232 },
  { month: 'Jul', revenue: 4343, cost: 7500, netProfit: -3157, powerConsumption: 1343 },
  { month: 'Aug', revenue: 9388, cost: 5300, netProfit: 4088, powerConsumption: 2388 },
  { month: 'Sep', revenue: 2324, cost: 4500, netProfit: -2176, powerConsumption: 1324 },
  { month: 'Oct', revenue: 4564, cost: 5500, netProfit: -936, powerConsumption: 2564 },
  { month: 'Nov', revenue: 9736, cost: 5400, netProfit: 4336, powerConsumption: 1736 },
  { month: 'Dec', revenue: 8875, cost: 5500, netProfit: 3375, powerConsumption: 2875 }
]

export const ANALYTICS_BIKES_DATA = [
  { month: 'Jan', model: 8000, rentals: 5900, maintenance: 100, distance: 1000, duration: 1000 },
  { month: 'Feb', model: 7000, rentals: 4300, maintenance: 200, distance: 2000, duration: 2000 },
  { month: 'Mar', model: 5000, rentals: 5400, maintenance: 400, distance: 4000, duration: 4000 },
  { month: 'Apr', model: 8000, rentals: 5800, maintenance: 200, distance: 1000, duration: 1000 },
  { month: 'May', model: 7669, rentals: 7300, maintenance: 369, distance: 2669, duration: 2669 },
  { month: 'Jun', model: 8232, rentals: 5300, maintenance: 232, distance: 1232, duration: 1232 },
  { month: 'Jul', model: 4343, rentals: 7500, maintenance: 157, distance: 1343, duration: 1343 },
  { month: 'Aug', model: 9388, rentals: 5300, maintenance: 488, distance: 2388, duration: 2388 },
  { month: 'Sep', model: 2324, rentals: 4500, maintenance: 176, distance: 1324, duration: 1324 },
  { month: 'Oct', model: 4564, rentals: 5500, maintenance: 936, distance: 2564, duration: 2564 },
  { month: 'Nov', model: 9736, rentals: 5400, maintenance: 46, distance: 1736, duration: 1736 },
  { month: 'Dec', model: 8875, rentals: 5500, maintenance: 275, distance: 2875, duration: 2875 }
]

export const ANALYTICS_MEMBERS_DATA = [
  { month: 'Jan', male: 8000, female: 5900 },
  { month: 'Feb', male: 7000, female: 4300 },
  { month: 'Mar', male: 5000, female: 5400 },
  { month: 'Apr', male: 8000, female: 5800 },
  { month: 'May', male: 7669, female: 7300 },
  { month: 'Jun', male: 8232, female: 5300 },
  { month: 'Jul', male: 4343, female: 7500 },
  { month: 'Aug', male: 9388, female: 5300 },
  { month: 'Sep', male: 2324, female: 4500 },
  { month: 'Oct', male: 4564, female: 5500 },
  { month: 'Nov', male: 9736, female: 5400 },
  { month: 'Dec', male: 8875, female: 5500 }
]
